module.exports = __webpack_public_path__ + "static/media/img_homepage_menu_03-Featured_default.1bd78ecf.png";